var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpPriceUpdateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 89,
    rx: 10,
    fill: "#019371"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 86,
    height: 86,
    rx: 8.5,
    fill: "#019371",
    stroke: "#D7FFC2",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_767_772",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 89,
    height: 89
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 88,
    height: 88,
    rx: 9.5,
    fill: "#D9D9D9",
    stroke: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_767_772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-33.0002 79.2626C21.1013 39.9572 22.2484 85.5618 96.0031 85.3828",
    stroke: "#D7FFC2",
    strokeOpacity: 0.35,
    strokeWidth: 2.2069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8877 5.39257C39.0249 47.8567 44.6486 -1.4758 -20.9998 -1.35469",
    stroke: "#D7FFC2",
    strokeOpacity: 0.35,
    strokeWidth: 2.2069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2988 57.75C58.7215 58.7499 57.2785 58.7499 56.7012 57.75L44.5762 36.75C43.999 35.75 44.7213 34.5 45.876 34.5L70.124 34.5C71.2787 34.5 72.001 35.75 71.4238 36.75L59.2988 57.75Z",
    fill: "#D0FFBB",
    stroke: "#019371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7012 30.25C35.2785 29.2501 36.7215 29.2501 37.2988 30.25L49.4238 51.25C50.001 52.25 49.2787 53.5 48.124 53.5H23.876C22.7213 53.5 21.999 52.25 22.5762 51.25L34.7012 30.25Z",
    fill: "#D0FFBB",
    stroke: "#019371"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpPriceUpdateIcon);
export default __webpack_public_path__ + "static/media/lpPriceUpdate_icon.54fdaafd8c8b92f73cc21b10f6c41e35.svg";
export { ForwardRef as ReactComponent };